import {Box, CircularProgress, Stack} from "@mui/material";

import type {FileTreeEntry, MaterialFileItem as MaterialFileItemType} from "../types";
import FileTreeFolderItem from "./FileTreeFolderItem";
import MaterialFileItem from "./MaterialFileItem";

type MaterialFilesContentProps = {
  loading: boolean;
  isSearchActive: boolean;
  materialFiles: MaterialFileItemType[];
  recommendationFiles: MaterialFileItemType[];
  otherFileTree: FileTreeEntry[];
  activeExportPath: string | null;
  onCopyFolderLink: (path: string) => void;
  onExportFolder: (path: string) => void;
}

const MaterialFilesContent = ({
                                loading,
                                isSearchActive,
                                materialFiles,
                                recommendationFiles,
                                otherFileTree,
                                activeExportPath,
                                onCopyFolderLink,
                                onExportFolder,
                              }: MaterialFilesContentProps) => {
  if (loading) {
    return <CircularProgress/>;
  }

  if (materialFiles.length === 0) {
    return null;
  }

  if (isSearchActive) {
    return (
      <Box sx={{p: 2.5, borderRadius: 2, backgroundColor: 'background.paper'}}>
        <Stack spacing={2}>
          {materialFiles.map((file) => (
            <MaterialFileItem key={file.id} item={file}/>
          ))}
        </Stack>
      </Box>
    );
  }

  return (
    <Stack spacing={3}>
      {recommendationFiles.length > 0 && (
        <Box>
          <Stack spacing={2} sx={{p: 2.5, borderRadius: 2, backgroundColor: 'background.paper'}}>
            {recommendationFiles.map((file) => (
              <MaterialFileItem key={file.id} item={file}/>
            ))}
          </Stack>
        </Box>
      )}
      {otherFileTree.length > 0 && (
        <Box>
          <Stack spacing={2}>
            {otherFileTree.some((entry) => entry.type === 'file') && (
              <Box sx={{p: 2.5, borderRadius: 2, backgroundColor: 'background.paper'}}>
                <Stack spacing={2}>
                  {otherFileTree.map((entry) => (
                    entry.type === 'file' ? <MaterialFileItem key={entry.file.id} item={entry.file}/> : null
                  ))}
                </Stack>
              </Box>
            )}
            {otherFileTree.map((entry) => (
              entry.type === 'folder' ? (
                <FileTreeFolderItem
                  key={`folder-0-${entry.name}`}
                  folder={entry}
                  level={0}
                  onCopyFolderLink={onCopyFolderLink}
                  onExportFolder={onExportFolder}
                  isExporting={activeExportPath === entry.path}
                  activeExportPath={activeExportPath}
                />
              ) : null
            ))}
          </Stack>
        </Box>
      )}
    </Stack>
  );
};

export default MaterialFilesContent;
